/**
 * Whether a gated query sub-hook should run: only when the caller is authorized
 * AND hasn't explicitly disabled it. Centralizes the authorization/enabled merge
 * every gated action applies to its query siblings, so the rule lives in one place
 * while the option spread stays at each call site (where its specific type is known).
 */
export function gateEnabled(
  isAuthorized: boolean,
  callerEnabled: boolean | undefined,
): boolean {
  return isAuthorized && (callerEnabled ?? true);
}
